// ── Null-safe text helpers ──────────────────────────────────────────────────
//
// Pure, dependency-free. Extracted so render paths never call String methods on
// a value that TypeScript believes is a `string` but can be null/undefined at
// runtime (malformed API row, legacy record). A single such call throws during
// render and — with the app's dark body background — surfaces as a black screen.

/** Coerce any value to a lowercase string without throwing on null/undefined. */
export function lower(v: unknown): string {
  return v == null ? "" : String(v).toLowerCase();
}

/**
 * True if the lowercased query is a substring of ANY of the given fields.
 * Every field is coerced safely, so null/undefined fields are simply skipped
 * instead of throwing. An empty/whitespace query matches everything.
 */
export function anyFieldIncludes(fields: Array<unknown>, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return fields.some((f) => lower(f).includes(q));
}

/**
 * Up-to-two-letter uppercase initials from a name, safe against null/undefined/
 * empty/whitespace-only input (falls back to "?").
 */
export function initialsOf(name: unknown): string {
  const s = name == null ? "" : String(name).trim();
  if (!s) return "?";
  return (
    s
      .split(/\s+/)
      .map((w) => w[0] ?? "")
      .slice(0, 2)
      .join("")
      .toUpperCase() || "?"
  );
}
